import styled from "styled-components";

export const BookPage = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 50px;
	flex-direction: column;
	input{
		display: flex;
		padding: 12px 16px;
		align-items: center;
		gap: 10px;
		align-self: stretch;
		border-radius: 20px;
		border: 1px solid #DDD;
		background: #F0F1F2;
	}
`

export const UploadHeader = styled.div`
	width: 838px;
	height: 72px;
	border-radius: 20px 20px 0px 0px;
	border: 1px solid #F0F1F2;
	background: #FFF;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 0px 35px;
	span {
		color: #242323;
		font-family: Public Sans;
		font-size: 24px;
		font-style: normal;
		font-weight: 500;
		line-height: 36px;
	}
`

export const HeaderLogo = styled.div`
	display: flex;
	flex-direction: row;
	gap: 5px;
	div{
		width: 30px;
		height: 16px;
		border-radius: 4px;
	}
`

export const UploadBody = styled.div`
	width: 838px;
	border-radius: 0px 0px 20px 20px;
	border: 1px solid #F0F1F2;
	background: #FFF;
`

export const BodyHeader = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 15px 35px;
	span{
		color: #4A4F58;
		font-family: Public Sans;
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 36px;
	}
	div{
		display: inline-flex;
		padding: 8px 10px;
		align-items: center;
		border-radius: 24px;
		background: #DFE8FB;
		color: #0047B6;
		text-align: center;
		font-family: Public Sans;
		font-size: 16px;
		font-style: normal;
		font-weight: 700;
		line-height: 24px;
	}
`

export const BookGeneralInfo = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 0px 50px;
`

export const BookCover = styled.div`
	div{
		width: 215px;
		height: 58px;
		margin: 20px 0px;
		flex-shrink: 0;
		border-radius: 20px;
		background: #F3C046;
	}
	img{
		position: absolute;
		margin-left: 17px;
		top: 212px;
	}
`

export const BookMainInfo = styled.div`
	

	.LowerInfo{
		display: flex;
		flex-direction: row;
		margin-top: 15px;
		.NPages{
			margin-left: 25px;
		}
	}

	span{
		color: var(--shade-shade-60, #727780);
		font-family: Public Sans;
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		line-height: 24px; /* 171.429% */
		margin-left: 15px;
	}
`

export const GrayLine = styled.div`
	width: 671px;
	height: 1px;
	flex-shrink: 0;
	stroke-width: 2px;
	background-color: #E5E7EB;
`

export const AddBtn = styled.button`
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	width: 631px;
	height: 32px;
	padding: 8px 0px;
	border-radius: 24px;
	background: #DFE8FB;
	border: none;
	margin: 30px 0px 30px 100px;
	span{
		color: #0047B6;
		text-align: center;
		font-family: Public Sans;
		font-size: 14px;
		font-style: normal;
		font-weight: 700;
		line-height: 24px;	
	}
`